import { Link } from "react-router-dom";
import { useState } from "react";
const Login = () => {
  const [isUsernameFocused, setIsUsernameFocused] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);

  return (
    <div className="flex p-6 flex-col items-center mt-16">
      <Link to="/">
        <div className="absolute text-2xl left-6 top-6 font-bold arrow">
          {"<"}
        </div>
      </Link>

      <div className="text-left">
        <h2 className="font-semibold text-3xl">Welcome Back</h2>
        <p className="text-base text-gray-600 mt-4">
          Log In to your Placoo account to explore your dream place to live
          across the whole world!
        </p>
      </div>
      <div className="bg-white w-full mt-8">
        <div className="mb-4">
          <label htmlFor="username" className="block text-left mb-2">
            Username
          </label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2">
              <i
                className={`fas fa-user ${
                  isUsernameFocused ? "violet-text" : "text-gray-600"
                }`}></i>
            </span>
            <input
              type="text"
              name="username"
              id="username"
              className={`w-full py-2 pl-10 border rounded-full ${
                isUsernameFocused ? "violet-bg" : ""
              }`}
              onFocus={() => setIsUsernameFocused(true)}
              onBlur={() => setIsUsernameFocused(false)}
            />
          </div>
        </div>

        <div className="mb-6">
          <label htmlFor="password" className="block text-left mb-2">
            Password
          </label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2">
              <i
                className={`fas fa-key ${
                  isPasswordFocused ? "violet-text" : "text-gray-600"
                }`}></i>
            </span>
            <input
              type="password"
              name="password"
              id="password"
              className={`w-full py-2 pl-10 border rounded-full ${
                isPasswordFocused ? "violet-bg" : ""
              }`}
              onFocus={() => setIsPasswordFocused(true)}
              onBlur={() => setIsPasswordFocused(false)}
            />
          </div>
        </div>
      </div>
      <div className=" w-full flex flex-col justify-center mt-4">
        <button className="mb-2 violet-button rounded-full w-full py-3">
          Log in
        </button>
        <p className="text-gray-400 text-sm">Forgot Password?</p>
        <div className="my-8 text-center">
          <div className="relative">
            <hr className="mx-4 w-full border-t border-violet-300" />
            <span className="absolute font-semibold rounded-lg w-10 bg-violet-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-2 text-gray-500">
              OR
            </span>
          </div>
        </div>
        <div className="text-center">
          <button className="flex items-center justify-center w-full p-2 mb-4 bg-black text-white rounded-full">
            <i className="fab fa-apple text-lg ml-2"></i>
            <span className="flex-1">Sign in with Apple</span>
          </button>
          <button className="flex items-center justify-center w-full mr-2 p-2 border rounded-full">
            <i className="fab fa-google text-lg ml-2"></i>
            <span className="flex-1 w-2/3">Sign in with Google</span>
          </button>
        </div>
      </div>
    </div>
  );
};
export default Login;
